/**
 * The list with one item moved by the given distance, or the list as it was
 * for a move that would carry it off either end. The Move buttons and a drop
 * both end here, so the buttons at either end can be pressed without harm.
 */
export function moveItem<T>(items: T[], index: number, by: number): T[] {
  const to = index + by
  if (to < 0 || to >= items.length) return items
  const moved = [...items]
  const [item] = moved.splice(index, 1)
  moved.splice(to, 0, item)
  return moved
}
